import React from 'react';
import PropTypes from 'prop-types';

import AvailableUsers from './available_users';
import SelectedUsers from './selected_users';

import './styles.scss';

const UserSelector = ({ selectedUserIds, users, onChange }) => (
  <div className="user-selector item-selector row">
    <div className="col-xs-6">
      <h5>Disabled Users</h5>
      <AvailableUsers
        selectedUserIds={selectedUserIds}
        users={users}
        onChange={onChange}
      />
    </div>

    <div className="col-xs-6">
      <h5>Enabled Users</h5>
      <SelectedUsers
        selectedUserIds={selectedUserIds}
        users={users}
        onChange={onChange}
      />
    </div>
  </div>
);

UserSelector.propTypes = {
  selectedUserIds: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,

  onChange: PropTypes.func.isRequired
};

export default UserSelector;
